import {createSlice} from "@reduxjs/toolkit";

export const reducerName = "images";
export const initialState = {
    images: [
        {
            src: "",
            showControls: false
        }
    ],
    showVideo: false,
};

const imagesReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setImageObj: (state, action) => ({
            ...state,
            images: [{
                src: action.payload,
                showControls: false
            }]
        }),
        setShowVideo: (state, action) => ({
            ...state,
            showVideo: action.payload,
        }),
    }
});

export default imagesReducer.reducer;
export const {
    setImageObj,
    setShowVideo
} = imagesReducer.actions;
